export enum ActiveType {
    ACTIVE = 'ACTIVE',
    NOT_ACTIVE = 'NOT_ACTIVE'
}

export enum ExecutionStatusType {
    AUTOMATIC = 'AUTOMATIC',
    MANUAL = 'MANUAL'
}



// WEBPACK FOOTER //
// ./src/Models/EnumTypes/ContractEnumTypes.ts